// extracted by mini-css-extract-plugin
export default {"spinner":"AudioLibraryContainer_spinner__KTytv"};